import { memo, useMemo } from "react"
import { useUser } from "@tm/context-distribution"
import { SystemType } from "@tm/models"
import Morpheus, { BundleMicroContext, createMicro } from "@tm/morpheus"
import { CompleteProfileDialog } from "../user-settings/components/CompleteProfileDialog"
import { EditProfileModal } from "../user-settings/components/EditProfileModal"
import { UserSettingsDialog } from "./components/UserSettingsDialog"
import { CheckUserCredentialsSet } from "./components/CheckUserCredentialsSet"

type SettingDialogsProps = {
    morpheus: Morpheus
}

export const SettingDialogs = memo(({ morpheus }: SettingDialogsProps) => {
    const { userContext } = useUser()

    const microContextState = useMemo(() => {
        return createMicro.bind(
            undefined,
            morpheus.context,
            { type: "component", bundle: "nobundle", component: "SettingDialogs" },
            morpheus.context.rootActions$,
            ""
        )
    }, [morpheus.context])

    if (userContext.system.systemType !== SystemType.Next) {
        return null
    }

    return (
        <BundleMicroContext.Provider value={microContextState}>
            <UserSettingsDialog />
            <EditProfileModal
                username={userContext.account?.username ?? ""}
                initialName={userContext.generalContact?.name ?? ""}
                initialEmail={userContext.generalContact?.email ?? ""}
            />
            <CompleteProfileDialog />
            <CheckUserCredentialsSet />
        </BundleMicroContext.Provider>
    )
})
